module.exports = __webpack_public_path__ + "assets/3630644f2e59b7f0761717b9dde8d1b0.png";